export default "__VITE_ASSET__Bbms7at$__"